import * as angular from "angular";

let HouseOccupantsViewComponent = {
    selector: "vcHouseOccupantsView",
    templateUrl:
        "/angular/components/house-occupant/house-occupants-view.component.html",
    bindings: {
        doubleToolbar: "=?",
    },
    controller: "PeopleController",
};

angular
    .module("houseoccupant")
    .component(
        HouseOccupantsViewComponent.selector,
        HouseOccupantsViewComponent
    );
